import {
    UPDATE_ORGANIZATION_REQUEST,
	UPDATE_ORGANIZATION_SUCCESS,
	UPDATE_ORGANIZATION_ERROR,
    LEAVE_ORGANIZATION_REQUEST,
	LEAVE_ORGANIZATION_SUCCESS,
	LEAVE_ORGANIZATION_ERROR,
	DELETE_ORGANIZATION_REQUEST,
	DELETE_ORGANIZATION_SUCCESS,
  DELETE_ORGANIZATION_ERROR,
  INVITE_USER_SUCCESS,
  INVITE_USER_ERROR,
  INVITE_USER_REQUEST,
  INVITE_NEW_USER_SUCCESS,
  INVITE_NEW_USER_ERROR,
  INVITE_NEW_USER_REQUEST,
  REMOVE_USER_SUCCESS,
  REMOVE_USER_ERROR,
  REMOVE_USER_REQUEST,
  REINVITE_USER_SUCCESS,
  REINVITE_USER_ERROR,
  REINVITE_USER_REQUEST,
  GET_USER_ORGANIZATIONS_REQUEST,
  GET_USER_ORGANIZATIONS_SUCCESS
} from '../../Actions/EndUser/OrganizationAction';

import {
  SET_USER_ID
} from '../../Actions/EndUser/AuthActions';

const initialState = {
  userId: null,
  loading: false,
  error: '',
  updating: false,
  leaving: false,
  deleting: false,
  inviting: false,
  removing: false,
  reinviting: false,
  updateOrganizations: false,
  newOrganization: null
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_USER_ID:
      return {
          ...state,
          userId: action.payload
      };
    case UPDATE_ORGANIZATION_REQUEST:
      return {
        ...state,
        updating: true
      };
    case UPDATE_ORGANIZATION_SUCCESS:
      return {
        ...state,
        updating: false,
        newOrganization: action.payload.organization
      };
    case UPDATE_ORGANIZATION_ERROR:
      return {
        ...state,
        updating: false,
        error: action.payload
      };
    case LEAVE_ORGANIZATION_REQUEST:
        return {
          ...state,
          leaving: true
        };
    case LEAVE_ORGANIZATION_SUCCESS:
        return {
          ...state,
          leaving: false,
        };
    case LEAVE_ORGANIZATION_ERROR:
        return {
          ...state,
          leaving: false,
          error: action.payload
        };
    case DELETE_ORGANIZATION_REQUEST:
      return {
        ...state,
        deleting: true
      };
    case DELETE_ORGANIZATION_SUCCESS:
      return {
        ...state,
        deleting: false
      };
    case DELETE_ORGANIZATION_ERROR:
      return {
        ...state,
        deleting: false,
        error: action.payload
      };
    case GET_USER_ORGANIZATIONS_REQUEST:
			return {
				...state,
				loading: true
			};
    case GET_USER_ORGANIZATIONS_SUCCESS:
			return {
				...state,
				loading: false,
        organizationUsers: action.payload,
        updateOrganizations: false
			};
    case INVITE_USER_REQUEST:
      return {
        ...state,
        inviting: true
      };
    case INVITE_USER_SUCCESS:
      return {
        ...state,
        inviting: false,
        updateOrganizations: true
      };
    case INVITE_USER_ERROR:
      return {
        ...state,
        inviting: false,
        error: action.payload
      };
    case INVITE_NEW_USER_REQUEST:
      return {
        ...state,
        inviting: true
      };
    case INVITE_NEW_USER_SUCCESS:
      return {
        ...state,
        inviting: false,
        updateOrganizations: true
      };
    case INVITE_NEW_USER_ERROR:
      return {
        ...state,
        inviting: false,
        error: action.payload
      };
    case REMOVE_USER_REQUEST:
      return {
        ...state,
        removing: true
      };
    case REMOVE_USER_SUCCESS:
      return {
        ...state,
        removing: false,
        updateOrganizations: true
      };
    case REMOVE_USER_ERROR:
      return {
        ...state,
        removing: false,
        error: action.payload
      };
    case REINVITE_USER_REQUEST:
      return {
        ...state,
        reinviting: true
      };
    case REINVITE_USER_SUCCESS:
        return {
            ...state,
            reinviting: false,
            alertType: "success",
            alertVisible: true,
            alertMessage: action.message
        };
    case REINVITE_USER_ERROR:
      return {
          ...state,
          reinviting: false,
          alertType: "danger",
          alertVisible: true,
          alertMessage: action.message
      };
    default:
      return state;
  }
};
